import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-900">This page has not been generated</h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base text-foreground-600">Tell me more about this page, so I can generate it</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-8 bg-primary-500 text-white font-semibold text-sm px-6 py-3 rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}